
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { stateType } from './showImageType'
import { ImagePreview  } from 'vant'
function stateData(){
    return {
        imgList:[]
    }
}
export default defineComponent({
    setup() {
        const state = reactive<stateType>(stateData())
        const route = useRoute()
        onMounted(()=>{
            state.imgList = JSON.parse(route.query.imgList as string)
        })
        return {
            ...toRefs(state),
            ...userEvent(state)
        }
    },
})
const userEvent = (state:stateType) => {
    const onClickImg = (index:number) => {
        ImagePreview({
            images:state.imgList.map((item:any) =>{return item.url}),
            startPosition: index
        })
    }
    return {
        onClickImg
    }
}
